export enum FileUploadType {
  LIBRARY = 'LIBRARY',
  USER_AVATAR = 'USER_AVATAR',
  COMUNICADO = 'COMUNICADO',
  IMAGES = 'IMAGES',
  DOCUMENTOS_COMPROBATORIOS = 'DOCUMENTOS_COMPROBATORIOS'
}
